import RemoteControlWrapper, { IRemoteControlWrapperProps } from '@src/page/toc/common/meeting-room-manager/components/mobile-remote-control/wrapper';
import { LiveState, LiveStateChanged } from '@tencent/live-components';

export default class RemoteControlPcWrapper extends RemoteControlWrapper {
    public constructor(props: IRemoteControlWrapperProps) {
        super(props);
        this.props.remoteControlManager.event.on(LiveStateChanged, this.onLiveStateChange);
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();
        this.props.remoteControlManager.event.off(LiveStateChanged, this.onLiveStateChange);
    }

    protected initRoom() {
        // pc 端直接初始化房间并进入，暂时不考虑异常
        this.props.remoteControlManager.initRoomInfoAndEnter();
    }

    private onLiveStateChange = (args: [LiveState, string]) => {
        const state = args[0] || 0;
        switch (state) {
            case LiveState.OnAir:
                break;
            case LiveState.Pause:
                this.handlerLiveStateOnPause();
                break;
            case LiveState.Ended:
                break;
            default:
                break;
        }
    };

    private handlerLiveStateOnPause() {
        // 手机端退出演示，电脑端也退出
        const { remoteControlManager } = this.props;
        this.props.onPlayEnd?.(remoteControlManager.currentPage);
    }
}
